export default "__VITE_ASSET__6eb8d885__"